<script lang="ts">
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { pdpSellerInfoData } from '../store/pdp_store';

  export let icon = 'X';
  export let description = '';
  export let collectInHours = '';
  export let icihtime = '';
  export let isCfsPreOrder = false;

  export let deliveryType = null;
  export let showMPdeliveryRange = false;
  export let isMarketplaceProduct: boolean = false;

  let mpDeliveryKey = 'extra.marketplace.product.deliveryleadtime.label';
  const earliestDeliveryDays = $pdpSellerInfoData?.marketPlaceOfferData?.earliestDeliveryDays;
  const latestDeliveryDays = $pdpSellerInfoData?.marketPlaceOfferData?.latestDeliveryDays;
</script>

<section class="product_delivery_description">
  {#if icon.length > 0}
    <Icon glyph={icon} type="primary" mobileSize={24} desktopSize={24} />
  {/if}
  {#if isCfsPreOrder}
    <div class="description">
      <Text key="extra.cfs.preorder.collection.time.pdp" args={[collectInHours]} />
    </div>
  {:else if deliveryType === null}
    <div class="description">
      {#if description.length > 0}
        {description}
      {:else if icihtime == ''}
        <Text key="extra.pdp.collect_in_time" args={[collectInHours]} />
      {:else}
        <Text key="extra.pdp.collect_in_time_before" args={[collectInHours, icihtime]} />
      {/if}
      <span class="delivery-free"><Text key="text.free" /></span>
    </div>
  {:else}
    <div class="delivery-info">
      {#if isMarketplaceProduct && showMPdeliveryRange}
        <div class="delivery-type">
          {#if earliestDeliveryDays && latestDeliveryDays}
            <Text key={mpDeliveryKey} args={[earliestDeliveryDays, latestDeliveryDays]} />
          {:else}
            <Text key="extra.marketplace.product.delivery.withoutdays" />
          {/if}
        </div>
      {:else}
        <div class="delivery-type">{deliveryType}</div>
      {/if}
    </div>
  {/if}
</section>
{#if isMarketplaceProduct && showMPdeliveryRange}
  <div class="mp-delivery-range-msg">
    <Text key="extra.marketplace.product.deliverydate.confirmoncheckout.label" />
  </div>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .product_delivery_description {
    display: flex;
    align-items: center;
    gap: 8px;

    .description {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      .delivery-free {
        color: $functional-orange-02;
        font-weight: 700;
        line-height: 18px;
        padding-left: 6px;
        text-transform: uppercase;
      }
    }

    .delivery-info {
      display: flex;
      flex-grow: 1;
      gap: 8px;
      @include desktop-min-width {
        flex-grow: inherit;
      }
      .delivery {
        &-type {
          flex-grow: 1;
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
        }
        &-date {
          font-weight: 700;
          font-size: 14px;
          line-height: 16px;
        }
        &-cost {
          font-weight: 700;
          font-size: 14px;
          line-height: 16px;

          &.green {
            color: $functional-green-01;
          }
          &.orange {
            color: $functional-orange;
          }
        }
      }
    }
  }
  .mp-delivery-range-msg {
    font-size: 14px;
    line-height: 16px;
    margin: 8px 0;
  }
</style>
